export { default } from './default-highlight';
export { default as LightAsync } from './light-async';
export { default as Light } from './light';
export { default as PrismAsyncLight } from './prism-async-light';
export { default as PrismAsync } from './prism-async';
export { default as PrismLight } from './prism-light';
export { default as Prism } from './prism';